var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgPokal = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 80 80" }, props, { children: _jsx("path", { fill: "currentColor", d: "M46.675 65c0-9.753-4.448-9.603-4.448-20.426S53 31.49 53 15H23c0 16.49 10.772 18.75 10.772 29.573s-4.449 10.672-4.449 20.426h17.352z" }) }))); };
export default SvgPokal;
